import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { properties } from 'src/environments/properties';
import { AuthService } from "../../../shared/services/auth.service";
import { SubscriptionService } from "../../../shared/services/subscription.service";
import { _windowUtil, findNestedObj } from '../../../shared/utils/ui-utils';

declare let $: any;
declare let AB: any;
declare let window: any;

@Component({
  selector: 'app-cancel-freshpass',
  templateUrl: './cancel-freshpass.component.html',
  styleUrls: ['./cancel-freshpass.component.scss'],
  providers: [SubscriptionService]
})
export class CancelFreshpassComponent implements OnInit {
  @Output() cancelSuccessResponse = new EventEmitter();
  isServiceErrorSubject: Subject<boolean> = new Subject<boolean>();
  isServiceError$ = this.isServiceErrorSubject.asObservable();
  @Input() userSubscriptionDetails: any;

  @Input() cancelReasonsData: any;
  @Input() userInfo: any;
  @Input() currentEnvironment;

  cancelReasonsList;
  cancelUserEligibilityData: {
    refundEligibleDays: number,
    cancellationDate: string,
    renewalReminderDays: number,
    isRefundEligible: boolean
  }
  retentionPlanDiscounts;

  showLoader = true;
  errorMessage;
  isServiceError = false;
  isFormValueValid = false;
  cancelReasonForm: FormGroup;
  discountPricePlan = 'fresh plan';
  $: any;
  displaySubTypeLink: boolean = false;
  selectedReason: string = '';
  currentPlanExpiryDate: string = '';
  formattedExpiryDate: string = '';
  displayDiscountSelection: boolean = false;

  isUpdating: boolean = false;

  HEADING_KEY: string = 'heading';

  properties = properties;
  cancelBenefitsTilesJSON: any;
  public windowUtil = _windowUtil(window);

  constructor(public subscriptionService: SubscriptionService,
    public authService: AuthService,
    private activeRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    private router: Router,
    private titleService: Title) {
    this.setTitle('Freshpass - Cancel Plan')
  }

  ngOnInit(): void {
    this.getCurrentPlanExpiryDate();
    this.getPrechurnCancelBenefits();
    this.isServiceError = false;
    if (this.cancelReasonsData) {
      this.cancelReasonsList = this.cancelReasonsData?.Data;
      this.cancelUserEligibilityData = this.cancelReasonsData?.cancelUserEligibility;
      if (this.cancelReasonsList?.length > 0) {
        this.showLoader = false;
        this.cancelReasonForm = this.formBuilder.group({
          cancelChoice: [],
          cancelFeedback: [],
        });
        this.isFormValueValid = false;
      }
    }
  }

  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }

  getCurrentPlanExpiryDate() {
    if (this.userSubscriptionDetails?.curentPlanExpiryDate) {
      this.currentPlanExpiryDate = this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate	);
      this.formattedExpiryDate = this.subscriptionService.convertDateByMonthName(this.currentPlanExpiryDate);
    }
  }
  
  keepPlanLoad() {
    this.router.navigate([this.properties.urlPath.MANAGE_PLAN_PATH]);
  }

  handleChange(event, reasonId) {
    const targetValue = event.srcElement.value;
    this.selectedReason = reasonId;
    const cancelChoiceValue = (targetValue.toLowerCase().length > 0);
    if (cancelChoiceValue) {
      this.isFormValueValid = true;
    } else {
      this.isFormValueValid = false;
    }
  }

  getRequestFormParams(validateBanner?) {
    const params = this.cancelReasonForm.value;
    return params;
  }

  analyticsUpdatePageInfo() {
    if (window.digitalData) {
      if (window.digitalData.pageFilter) {
        window.digitalData.pageFilter.subscriptionFunnel = `${(this.userSubscriptionDetails?.isDiscountedPendingPrice ? 'disc:' : '')}plan-cancelled`;
      }
      if (window.digitalData.user) {
        window.digitalData.user.subscriptionStatus = `${(this.userSubscriptionDetails?.isDiscountedPendingPrice ? 'disc:' : '')}plan-cancelled`;
      }
    }
  }

  setAnalyticsLinkClick(link) {
    if (AB.DATALAYER) {
      AB.DATALAYER.setLinkClickEvents(link);
    }
  };

  retentionCheckCancelSubscriptionPlan() {
    this.callToCancelSubscriptionPlan(true);
  }

  displayCharCount(obj) {
    let feedbackLength = obj.currentTarget.value.length;
    let remainingWordLength = obj.currentTarget.maxLength - feedbackLength;
    if (obj.currentTarget.textLength === obj.currentTarget.maxLength) {
      $("#commentCharCount").text(obj.currentTarget.maxLength + " / 400 - Character limit exceeded.");
      $("#commentCharCount").attr('aria-label', remainingWordLength + " letters remaining out of 400 letters - Character limit exceeded.")
      $("#commentCharCount").addClass("feedback-char-count-maxlen");
      $("#dsCancelFeedback").addClass("cancel-feedback-maxlen")
    } else {
      if ($("#commentCharCount").hasClass("feedback-char-count-maxlen")) {
        $("#commentCharCount").removeClass("feedback-char-count-maxlen");
      }
      if ($("#dsCancelFeedback").hasClass("cancel-feedback-maxlen")) {
        $("#dsCancelFeedback").removeClass("cancel-feedback-maxlen")
      }
      $("#commentCharCount").text(feedbackLength + "/400");
      $("#commentCharCount").attr('aria-label', remainingWordLength + " letters remaining out of 400 letters")
    }
  }

  cancelPlan() {
    this.callToCancelSubscriptionPlan(false)
  }

  callToCancelSubscriptionPlan(retentionEligibilityCheck: boolean) {
    const cancelRequestFormObj = this.getRequestFormParams();
    const cancelReasonValue = cancelRequestFormObj.cancelChoice;
    const cancelComments = cancelRequestFormObj.cancelFeedback;
    this.showLoader = true;
    this.subscriptionService.cancelSubscription(this.userInfo, cancelReasonValue, cancelComments, this.currentEnvironment, retentionEligibilityCheck).subscribe((data) => {
      if (data && data.Data) {
        if (data?.Data?.isEligibleForRetentionDiscounts && data?.Data?.retentionPlanDiscounts && retentionEligibilityCheck) {
          this.retentionPlanDiscounts = data.Data.retentionPlanDiscounts
          this.displayDiscountSelection = true;
          this.showLoader = false;
          window.scrollTo(0, 0);
        } else {
          this.analyticsUpdatePageInfo();
          this.setAnalyticsLinkClick('subscription-cancel-success');
          this.showLoader = false;
          if (!$.isEmptyObject(data.Data)) {
            this.cancelSuccessResponse.emit(data.Data);
          }
        }
      } else {
        this.handleCancelError();
      }
    }, error => {
      this.handleCancelError(error)
    });
  }

  handleCancelError(error = null) {
    this.showLoader = false;
    this.isServiceErrorSubject.next(true);
    this.errorMessage = this.subscriptionService.errorHandling(error?.status, 'errorMessage', error?.responseJSON);
    this.isServiceError = true;
  }

  onErrorChange(newValue: boolean) {
    this.isServiceErrorSubject.next(newValue);
  }

  getPrechurnCancelBenefits() {
    this.subscriptionService.getPreChurnCancelBenefitsTiles(this.currentEnvironment).subscribe(data => {
      if (data) {
        const jsonData = JSON.parse(data)
        const cancelTitleHeader = findNestedObj(jsonData, this.HEADING_KEY);
        const tileObj = findNestedObj(jsonData, this.properties.confirmation.FRESHPASSTILEPARSYS);
        if (tileObj) {
          this.cancelBenefitsTilesJSON = { header: cancelTitleHeader, benefits: tileObj };
        }
      }
    }, error => {
      this.handleCancelError(error)
    });
  }

  getDiscountOptionSelected(): void {
    this.router.navigate([this.properties.urlPath.CHANGE_PLAN_PATH], {
      state: {
        userSubscriptionDetails: this.userSubscriptionDetails,
        retentionPlanDiscount: this.retentionPlanDiscounts[0],
        isRedirectedFromPrechurnDiscount: true
      }
    });
  }

  redirectToManagePlan() {
    this.router.navigate([this.properties.urlPath.MANAGE_PLAN_PATH]);
  }
}
